import { userModule } from '@/rules/page-access'
import { maAuthenticationGuard, maAuthorizationGuard, maParamsQueryNormalizeGuard } from '@/router/guards'
import { Query, RouteName, TitleFont } from '@/base/constants/route'

const userRoutes = {
  path: 'user',
  name: RouteName.USER,
  meta: {
    title: 'User',
    parent: true,
    ignoreParentFromMenu: true,
  },
  component: () => import('@/layouts/Dashboard.vue'),
  beforeEnter: maAuthenticationGuard,
  children: [
    {
      path: 'custom-alerts',
      name: RouteName.USER_CUSTOM_ALERTS,
      meta: {
        title: 'Custom Alerts',
        analyticsPageName: 'Custom Alerts',
        navigationWithoutAppTrack: true,
        ignoreFromMenu: true,
      },
      component: () => import('@/pages/customalerts/index.vue'),
      beforeEnter: maAuthorizationGuard,
    },
    {
      path: 'settings',
      name: RouteName.ACCOUNT_SETTINGS,
      meta: {
        title: 'Settings',
        titleFont: TitleFont.HEADLINE,
        analyticsPageName: 'Settings',
        navigationWithoutAppTrack: true,
        hideGlobalSearch: true,
      },
      component: () => import('@/pages/account-settings/index.vue'),
      redirect: { name: RouteName.ACCOUNT_SETTINGS_USER_DETAILS },
      children: [
        {
          path: 'user-details',
          name: RouteName.ACCOUNT_SETTINGS_USER_DETAILS,
          meta: {
            title: 'User Details',
            analyticsPageName: 'Settings - User Details',
          },
          components: {
            tab: () => import('@/pages/account-settings/user-details/index.vue'),
          },
        },
        {
          path: 'billing',
          name: RouteName.ACCOUNT_SETTINGS_BILLING,
          meta: {
            title: 'Billing',
            analyticsPageName: 'Settings - Billing',
          },
          components: {
            tab: () => import('@/pages/account-settings/billing/index.vue'),
          },
        },
        {
          path: 'plans',
          name: RouteName.ACCOUNT_SETTINGS_PLANS,
          meta: {
            title: 'Plans',
            analyticsPageName: 'Settings - Plans',
            requiredQueries: [
              Query.PRODUCT_FAMILY,
            ],
          },
          components: {
            tab: () => import('@/pages/account-settings/plans/index.vue'),
          },
          beforeEnter: maParamsQueryNormalizeGuard,
        },
        {
          path: 'team-members',
          name: RouteName.ACCOUNT_SETTINGS_TEAM_MEMBERS,
          meta: {
            title: 'Team Members',
            analyticsPageName: 'Settings - Team Members',
          },
          components: {
            tab: () => import('@/pages/account-settings/team-members/index.vue'),
          },
        },
        {
          path: 'api-usage',
          name: RouteName.ACCOUNT_SETTINGS_API_USAGE,
          meta: {
            title: 'API Usage',
            analyticsPageName: 'Settings - API Usage',
          },
          components: {
            tab: () => import('@/pages/account-settings/api-usage/index.vue'),
          },
        },
        {
          path: 'sso-settings',
          name: RouteName.ACCOUNT_SETTINGS_SSO_SETTINGS,
          meta: {
            title: 'SSO Settings',
            analyticsPageName: 'Settings - SSO Settings',
            requiredAccess: userModule.createSsoLoginAccessRule,
            ignoreFromMenuDependUnauthorized: true,
            sub: true,
          },
          components: {
            tab: () => import('@/pages/account-settings/sso-settings/index.vue'),
          },
          beforeEnter: maAuthorizationGuard,
        },
        {
          path: 'integrations',
          name: RouteName.ACCOUNT_SETTINGS_USER_INTEGRATION,
          meta: {
            title: 'Integrations',
            analyticsPageName: 'Integrations',
          },
          components: {
            tab: () => import('@/pages/account-settings/integrations/index.vue'),
          },
        },
      ],
    },
    {
      path: 'slack-integration',
      name: RouteName.USER_SLACK_INTEGRATION,
      meta: {
        title: 'Slack Integration',
        analyticsPageName: 'Slack Integration',
        ignoreFromMenu: true,
      },
      component: () => import('@/pages/slack-integration/index.vue'),
      alias: '/slack-integration',
    },
  ],
}

export default userRoutes
